/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnassignedInputs */

const en_unassigned = /** @type {(inputs: UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const de_unassigned = /** @type {(inputs: UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht zugewiesen`)
};

/**
* | output |
* | --- |
* | "Unassigned" |
*
* @param {UnassignedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const unassigned = /** @type {((inputs?: UnassignedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnassignedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_unassigned(inputs)
	return en_unassigned(inputs)
});